export const AppLanguage = {
  en: "en",
  fr: "fr",
} as const;

export type AppLanguageType = (typeof AppLanguage)[keyof typeof AppLanguage];

export interface SupportedLanguage {
  code: AppLanguageType;
  selectionLabel: string;
}

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: AppLanguage.fr, selectionLabel: "Français" },
  { code: AppLanguage.en, selectionLabel: "English" },
];

export const DEFAULT_LANGUAGE = AppLanguage.fr;
